import React, { useCallback, useEffect, useRef, useState } from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import { useModal } from '../../../../hooks/useModal';
import { nyTaskContent } from '../../../../constants/copyright';

const { afterAnswerModal } = nyTaskContent;

const QuizItemMultiple = React.forwardRef(function QuizItemMultiple(
  { image, text, answers, note_image, index, nextStep, setScore, note_title, note, isMove = false },
  ref,
) {
  const [answer, setAnswer] = useState([]);
  const captionRef = useRef();
  const captionSpanRef = useRef();

  const { addModal } = useModal();

  const setAnswerData = useCallback(
    (id) => {
      const isSelected = answer.includes(id);
      if (isSelected) {
        setAnswer((p) => [...p].filter((el) => el !== id));
      } else {
        setAnswer((p) => [...p, id]);
      }
    },
    [answer],
  );

  const nextStepLogic = () => {
    const successCallback = () => {
      nextStep();
      setScore(answer);
    };

    addModal({
      type: 'quizStartComponent',
      props: {
        ...afterAnswerModal,
        image: note_image,
        title: note_title,
        description: note,
        goToQuiz: successCallback,
        onClose: successCallback,
      },
    });
  };

  useEffect(() => {
    const caption = captionRef.current;
    const scale = Math.min(1, caption.clientHeight / caption.scrollHeight);
    if (scale < 1) captionSpanRef.current.style.fontSize = `${scale}em`;
  }, []);

  return (
    <div className={`quiz__item quiz__item_multiply ${answers?.length > 4 ? 'quiz__item_min' : ''}`} ref={ref}>
      <div className={'quiz__item-image'}>
        <img src={image} alt={''} />
      </div>
      <div className={'quiz__item-block'}>
        <h2 className='quiz__item-title' ref={captionRef}>
          <span ref={captionSpanRef}>{safeHTML(text)}</span>
        </h2>
        <div className={`quiz__item-items`}>
          <ul>
            {answers?.map(({ text, id }, i) => (
              <li key={`li-${i}`}>
                <CustomButton
                  className={classNames('custom-button_quiz-item quiz__item-option quiz__item-option-multiple', {
                    'quiz__item-option_active': answer?.includes(id),
                    'quiz__item-option-multiple_active': answer?.includes(id),
                  })}
                  key={`btn-${i}`}
                  text={text}
                  icon={'buttons/select'}
                  onClick={() => setAnswerData(id)}
                />
              </li>
            ))}
          </ul>
        </div>
        <CustomButton
          className={classNames('button_quiz-a quiz__item-button', {
            'custom-button_disabled': answer?.length === 0,
          })}
          text={'other.reply'}
          disabled={answer?.length === 0}
          disposable={true}
          onClick={nextStepLogic}
        />
      </div>
    </div>
  );
});

export default QuizItemMultiple;
QuizItemMultiple.propTypes = {};
